module.exports = __webpack_public_path__ + "img/lee_token.brpg.82edc9d.png";